import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TestimonialSection from './components/TestimonialSection';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import BlogGrid from './components/BlogGrid';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <TestimonialSection />
        <CategoryGrid />
        <AboutSection />
        <BlogGrid />
        <CTASection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'ACBuySpreadsheet',
            url: window.location.origin,
            logo: `${window.location.origin}/favicon.jpeg`,
            description: 'The ultimate China shopping spreadsheet system — buy from China smarter, cheaper, and safer.',
            sameAs: [
              'https://kaspreadsheet.com/',
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'ACBuySpreadsheet',
            url: window.location.origin,
            potentialAction: {
              '@type': 'SearchAction',
              target: {
                '@type': 'EntryPoint',
                urlTemplate: 'https://kaspreadsheet.com/search?q={search_term_string}',
              },
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
    </div>
  );
}